import { Debt } from '../../interfaces';
import { ELIGIBLE_UNSECURED_DEBT_ACCOUNT_TYPES } from './eligibleUnsecuredDebtAccountTypes';

export const isEligibleType = (debt: Debt): boolean => ELIGIBLE_UNSECURED_DEBT_ACCOUNT_TYPES.includes(debt.accountType);
